/**
 * Retorna uma cópia rasa do array, com os elementos passados trocados.
 *
 * @param {any[]} array
 * @param {number} fromIdx
 * @param {number} toIdx
 */
export const toSwapped = (array, from, to) => {
  const len = array.length;
  if (from < 0) {
    from = len + from;
  }
  if (to < 0) {
    to = len + to;
  }
  const arrCopy = [...array];
  [arrCopy[from], arrCopy[to]] = [arrCopy[to], arrCopy[from]];
  return arrCopy;
};